import { render, staticRenderFns } from "./EventsCreate.vue?vue&type=template&id=7c5b4819"
import script from "./EventsCreate.vue?vue&type=script&lang=js"
export * from "./EventsCreate.vue?vue&type=script&lang=js"
import style0 from "./EventsCreate.vue?vue&type=style&index=0&id=7c5b4819&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports